import { DRAWER_TYPES } from '@/constants/drawer';

import { ROLES } from '@/constants/roles';

export const polls = {
  name: 'TaskList',
  path: '/polls',
  component: () => import('./views/tasks-management.vue'),
  meta: {
    title: 'Задания',
    accessList: [ROLES.organization],
    // subdrawer: DRAWER_TYPES.portal,
    instruction: { id: 19, name: 'Задания' },
    icon: '$iedit',
  },
};

export const pollsCreate = {
  name: 'TaskCreate',
  path: '/polls/create',
  component: () => import('./views/task-management.vue'),
  meta: {
    title: 'Новое задание',
    accessList: [ROLES.organization],
  },
};

export const uiGrandingAssigment = {
  name: 'grading-assignments',
  path: '/grading-assignments',
  component: () => import('./views/grading-assignments.vue'),
  meta: {
    title: 'Оценка работ',
    layout: 'ui-design',
    accessList: [ROLES.expert],
  },
};

export const routes = [
  polls,
  pollsCreate,
  {
    name: 'TaskEdit',
    path: '/polls/edit/:id',
    component: () => import('./views/task-management.vue'),
    meta: {
      title: 'Редактирование задания',
      accessList: [ROLES.organization],
    },
  },
  {
    name: 'TemplateCreate',
    path: '/template-create',
    component: () => import('./views/TemplateCreate.vue'),
    meta: {
      title: 'Добавить шаблон',
    },
    accessList: [ROLES.organization],
  },
  {
    name: 'TemplateEdit',
    path: '/template-edit/:id',
    component: () => import('./views/TemplateEdit.vue'),
    meta: {
      title: 'Редактировать шаблон',
      accessList: [ROLES.organization],
    },
  },
  {
    name: 'ParticipantEvents',
    path: '/polls/event',
    component: () => import('./views/poll-events.vue'),
    meta: {
      title: 'Задания мероприятий',
      accessList: [ROLES.certificate, ROLES.member],
    },
  },
  {
    name: 'PollEvents',
    path: '/polls/event/:id',
    component: () => import('./views/PollEvents/index.vue'),
    meta: {
      title: 'Задания',
      accessList: [ROLES.certificate, ROLES.member, ROLES.organization, ROLES.expert],
      subdrawer: DRAWER_TYPES.portal,
    },
  },
  {
    name: 'PollPassing',
    path: '/polls/event/:eventId/stage/:stageId/poll/:id',
    component: () => import('./views/poll.vue'),
    meta: {
      title: 'Выполнение заданий',
      accessList: [ROLES.certificate, ROLES.member, ROLES.organization],
    },
  },
  {
    name: 'PollPassingQuestions',
    path: '/polls/event/:eventId/stage/:stageId/poll/:pollId/passing/:id',
    component: () => import('./views/poll-passing.vue'),
    meta: {
      title: 'Прохождение заданий',
      accessList: [ROLES.certificate, ROLES.member, ROLES.organization],
      subdrawer: DRAWER_TYPES.portal,
    },
  },
  {
    name: 'PollViewQuestions',
    path: '/polls/event/:eventId/stage/:stageId/poll/:pollId/view',
    component: () => import('./views/poll-passing.vue'),
    meta: {
      title: 'Просмотр заданий',
      readonly: true,
      accessList: [ROLES.certificate, ROLES.member, ROLES.organization],
      subdrawer: DRAWER_TYPES.portal,
    },
  },
  {
    name: 'StageUserPolls',
    path: '/polls/event/:eventId/stage/:id/journals',
    component: () => import('./views/StageUserPolls.vue'),
    meta: {
      layout: 'empty',
      title: 'Просмотр ответов',
      accessList: [ROLES.organization, ROLES.expert],
    },
  },
  {
    name: 'JournalAnswers',
    path: '/polls/journal/:id/answers',
    component: () => import('./views/poll-moderation.vue'),
    meta: {
      title: 'Просмотр ответов',
      accessList: [ROLES.organization, ROLES.expert],
    },
  },
  // {
  //   name: 'grading-assignments',
  //   path: '/grading-assignments',
  //   component: () => import('./views/grading-assignments.vue'),
  //   meta: {
  //     title: 'Оценка работ',
  //     accessList: [ROLES.expert],
  //   },
  // },
  uiGrandingAssigment,
  {
    name: 'grading-assignments-detail',
    path: '/grading-assignments/:id',
    component: () => import('./views/grading-assignments-detail.vue'),
    meta: {
      title: 'Оценка работы',
      layout: 'ui-design',
      accessList: [ROLES.expert],
    },
  },
];

export default routes;
